import { render, staticRenderFns } from "./Initials.vue?vue&type=template&id=53401e48&scoped=true&"
import script from "./Initials.vue?vue&type=script&lang=js&"
export * from "./Initials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53401e48",
  null
  
)

export default component.exports